import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout, resetAuth } from "../store/authSlice";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";

const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showLogout, setShowLogout] = useState(false);
  const { loginStatus } = useSelector((state) => state?.auth);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/auth/login");
  };

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <Button
      className = "new-logout-btn"
        onClick={() => setShowLogout(!showLogout)}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          fontSize: "57px",
          color: "#075E54",
          display: "flex",
          flexDirection: "column", 
          alignItems: "center",
        }}
      >
        <FontAwesomeIcon icon={faCog} />
      </Button>

      {showLogout && (
        <div className="new-logout-btn"
          style={{
            display: "flex",
            top: "76%",
            background: "white",
            padding: "8px 12px",
            borderRadius: "5px",
            boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
            textAlign: "center",
            minWidth: "120px",
          }}
        >
          <Button
            onClick={handleLogout}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              fontSize: "16px",
              display: "flex",
              alignItems: "center",
              color: "#d9534f",
            }}
          >
            <FontAwesomeIcon icon={faSignOutAlt} className="mb-0 mx-2" />
            Logout
          </Button>
        </div>
      )}
    </div>
  );
};

export default Logout;
